import { glsInjectDynatrace } from '@gls-its-frontends/common/gls-dynatrace';
import { Environment } from '../enums/environment';

const STAGE_DYNATRACE_RUM_APP_ID: string = '961be4de497a94f';
const PROD_DYNATRACE_RUM_APP_ID: string = '94076d5309da5db1';

const setUpDynatrace = (environment: Environment): void => {
    switch (environment) {
        case Environment.STAGE:
            glsInjectDynatrace(STAGE_DYNATRACE_RUM_APP_ID);
            break;
        case Environment.PROD:
            glsInjectDynatrace(PROD_DYNATRACE_RUM_APP_ID);
            break;
    }
};

export { setUpDynatrace };
